import React from 'react'

export const successfullSubmissionEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'form',
      eventAction: 'submission',
      eventLabel: 'success',
      eventValue: 60,
      nonInteraction: false,
    })
  }
}

export const registerEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'form',
      eventAction: 'register',
      eventLabel: 'success',
      eventValue: 80,
      nonInteraction: false,
    })
  }
}

export const failedSubmissionEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'form',
      eventAction: 'submission',
      eventLabel: 'failed',
      eventValue: 1,
      nonInteraction: false,
    })
  }
}

export const passwordToggleEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'form',
      eventAction: 'toggle',
      eventLabel: 'password',
      eventValue: 5,
      nonInteraction: false,
    })
  }
}

export const enteredFieldValue = (label) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'form',
      eventAction: 'input',
      eventLabel: label,
      eventValue: 5,
      nonInteraction: false,
    })
  }
}

export const logoutEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'authentication',
      eventAction: 'change state',
      eventLabel: 'logout',
      eventValue: 5,
      nonInteraction: false,
    })
  }
}
export const loginEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push('event', 'GAEvent', {
      eventCategory: 'authentication',
      eventAction: 'change state',
      eventLabel: 'log in',
      eventValue: 40,
      nonInteraction: false,
    })
  }
}

export const resetPasswordPageViewEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'page_view',
      page_title: 'Proteket | Glemt passord',
      page_location: 'https://proteket.no/login',
      nonInteraction: false,
    })
  }
}

export const selectedFilterEvent = (label) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'filtering',
      eventAction: 'select',
      eventLabel: label,
      eventValue: 7,
      nonInteraction: false,
    })
  }
}

export const filterHasMatchesEvent = (label) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'filtering',
      eventAction: 'has matches',
      eventLabel: label,
      eventValue: 2,
      nonInteraction: true,
    })
  }
}

export const filterDoesNotHavesMatchesEvent = (label) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'filtering',
      eventAction: 'no matches',
      eventLabel: label,
      eventValue: 2,
      nonInteraction: true,
    })
  }
}

export const sliderStopAndRead = (label) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'interaction',
      eventAction: 'stop',
      eventLabel: label,
      eventValue: 15,
      nonInteraction: false,
    })
  }
}

export const lockedPageEvent = (value) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory: 'authentication',
      eventAction: 'locked page',
      eventLabel: value,
      eventValue: 15,
      nonInteraction: true,
    })
  }
}
